import { useRequiredContext } from "@redotech/react-util/context";
import { useHandler } from "@redotech/react-util/hook";
import { ConciergeProductFormSettings } from "@redotech/redo-model/concierge-product-form/concierge-product-form";
import { ConciergeProductForm } from "@redotech/redo-storefront-common/concierge/concierge-product-form";
import { memo, useContext } from "react";
import { AuthenticatedShopifyExtensionClientContext } from "../client/authenticated-client-context";
import { RedoShopifyRpcClientContext } from "../client/redo-shopify-rpc-client";
import { getTeamInfo } from "../client/shopify-extension-client";
import { ExtensionShopifyClientContext } from "../shopify";
import {
  addSessionIdToCart,
  sendConciergeLoadedEvent,
} from "../utils/user-session";
import { useConciergeQuestions } from "./use-concierge-questions";
import { useConciergeTreatment } from "./use-concierge-treatment";

export const ConciergeProductFormShopifyWrapper = memo(
  function ConciergeProductFormShopifyWrapper({
    settings,
  }: {
    settings: ConciergeProductFormSettings;
  }) {
    const authenticatedShopifyExtensionClient = useContext(
      AuthenticatedShopifyExtensionClientContext,
    );
    const rpcClient = useContext(RedoShopifyRpcClientContext);
    const extensionShopifyClient = useRequiredContext(
      ExtensionShopifyClientContext,
    );

    const handleGetTeamInfo = useHandler(async () => {
      return getTeamInfo(authenticatedShopifyExtensionClient!);
    });

    const handleConciergeLoaded = useHandler(async () => {
      await Promise.all([
        sendConciergeLoadedEvent(rpcClient!),
        addSessionIdToCart(extensionShopifyClient),
      ]);
    });

    if (!rpcClient || !authenticatedShopifyExtensionClient) {
      return null;
    }

    return (
      <ConciergeProductForm
        getTeamInfo={handleGetTeamInfo}
        onConciergeLoaded={handleConciergeLoaded}
        settings={settings}
        useConciergeQuestions={useConciergeQuestions}
        useConciergeTreatment={useConciergeTreatment}
      />
    );
  },
);
